import React, { useEffect } from 'react';
import CustomTab from '../../components/ui/CustomTab';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { pushRoute, setSaveDashboardFormState } from '../../store/globalSlice';

const tabs = [
	{
		label: "File Upload/Download",
		to: "fileinterface",
        value :"/filetransfer/fileinterface"
	},
	{
		label: "Quota File Generation",
		to: "quotafile",
		value: "/filetransfer/quotafile",
	},
	// {
	// 	label: "Quota File Generation New",
	// 	to: "quotafilegenerate",
	// 	value: "/filetransfer/quotafilegenerate",
	// },  
];

 const FileTransfer = () => {
  const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setSaveDashboardFormState(false));
      dispatch(pushRoute("file-transfer"));
    }, []);
    return (
        <CustomTab tabs={tabs} />
      )
}

export default FileTransfer